export const CONTRACT_LOAD_REQUEST = 'CONTRACT_LOAD_REQUEST';
export const CONTRACT_LOAD_SUCCESS = 'CONTRACT_LOAD_SUCCESS';
export const CONTRACT_LOAD_FAILURE = 'CONTRACT_LOAD_FAILURE';
export const CONTRACT_LOAD_AVAILABLE_DRIVERS = 'CONTRACT_LOAD_AVAILABLE_DRIVERS';
